import { render, staticRenderFns } from "./sportselect.vue?vue&type=template&id=560972c7&scoped=true&"
import script from "./sportselect.vue?vue&type=script&lang=js&"
export * from "./sportselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560972c7",
  null
  
)

export default component.exports